import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AssetsSellingInfoForm from '../../../components/forms/assets-selling-info-form';
import SellingInfoContainer from '../../../containers/selling-info-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../../modules/table-wrapper/table-wrapper';
import { getSale } from '../../../store/actions/operations-sign';
import { RootState } from '../../../types';
import { OperationComplete, BlockchainExplorerButton } from 'components';
import { IconBtn } from '@ru-digital-assets/ui-component';
import currencyFormat from 'utils/currencyFormat';
import { CopyIcon } from 'assets/icons';

const AssetInfoPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const id = history.location.state?.id;
  const isHistory = history.location.state?.isHistory;
  const purchase: any = useSelector(
    (state: RootState) => state.operationsSign.data.sale
  );

  console.log('purchase.status', purchase?.status);

  useEffect(() => {
    if (id) {
      dispatch(getSale({ id }));
    }
  }, [id]);

  const [showSignSaleResultScreen, setShowSignSaleResultScreen] = useState(
    false
  );
  const [showSignPayResultScreen, setShowSignPayResultScreen] = useState(false);

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/history', title: 'Операции' },
                {
                  link: '/history',
                  title: purchase?.isInitiator ? 'Продажа' : 'Покупка',
                },
              ]}
              tabName="sale"
              iconType="history"
            />
          </div>
        </div>
        {showSignSaleResultScreen ? (
          <OperationComplete
            title="Продажа цифровых финансовых активов"
            onClose={() => history.push('/assets')}
            main={
              <>
                <p className="p p_font-size_32 p_font-weight_light mb_32 text-center">
                  Транзакция успешно подписана
                </p>
                <p className="p p_font-size_18 mb_32 text-center">
                  Транзакция успешно подписана и заявка №{purchase?.id} на
                  покупку {purchase?.tokenCount} токенов {purchase?.tokenName}{' '}
                  отправлена Покупателю
                </p>
                {purchase?.blockchainTransactionId && (
                  <div className="flex align-center mb_32">
                    <p className="p p_font-size_18 mr_10">
                      ID транзакции:{' '}
                      {purchase?.blockchainTransactionId.slice(0, 20) +
                        '..' +
                        purchase?.blockchainTransactionId.slice(-15)}
                    </p>
                    <CopyIcon
                      className="cursor-pointer"
                      width={20}
                      height={20}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          purchase?.blockchainTransactionId
                        );
                      }}
                    />
                  </div>
                )}
                <div className="flex">
                  <div className="mr_16">
                    <BlockchainExplorerButton trxnId={purchase?.blockchainTransactionId}/>
                  </div>
                  <IconBtn
                    title="Перейти в операции"
                    onClick={() => history.push('/history')}
                  />
                </div>
              </>
            }
          />
        ) : showSignPayResultScreen ? (
          <OperationComplete
            title="Продажа цифровых финансовых активов"
            onClose={() => history.push('/assets')}
            main={
              <>
                <p className="p p_font-size_32 p_font-weight_light mb_32 text-center">
                  Факт оплаты подтвержден
                </p>
                <p className="p p_font-size_18 mb_32 text-center">
                  Факт оплаты {purchase?.tokenCount} токенов{' '}
                  {purchase?.tokenName} на сумму{' '}
                  {currencyFormat(
                    purchase?.tokenCount * purchase?.tokenPrice,
                    true
                  )}{' '}
                  подтвержден
                </p>
                {purchase?.blockchainTransactionId && (
                  <div className="flex align-center mb_32">
                    <p className="p p_font-size_18 mr_10">
                      ID транзакции:{' '}
                      {purchase?.blockchainTransactionId.slice(0, 20) +
                        '..' +
                        purchase?.blockchainTransactionId.slice(-15)}
                    </p>
                    <CopyIcon
                      className="cursor-pointer"
                      width={20}
                      height={20}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          purchase?.blockchainTransactionId
                        );
                      }}
                    />
                  </div>
                )}
                <div className="flex">
                  <div className="mr_16">
                    <BlockchainExplorerButton trxnId={purchase?.blockchainTransactionId}/>
                  </div>
                  <IconBtn
                    title="Перейти в операции"
                    onClick={() => history.push('/history')}
                  />
                </div>
              </>
            }
          />
        ) : (
          <div className="row">
            <div className="col-19 col-lg-27 col-xl-35">
              <TableWrapper>
                <div className="ucp">
                  <div className="ucp__header">
                    <TableHeaderWrapper
                      // isHint
                      // hintPage="SALE"
                      leftContent={`${
                        purchase?.isInitiator ? 'Продажа' : 'Покупка'
                      } цифровых финансовых активов`}
                      onCloseClick={() =>
                        history.replace(isHistory ? '/history' : '/assets')
                      }
                    />
                  </div>
                  <div className="ucp__body">
                    <AssetsSellingInfoForm
                      onSignSale={() => {
                        dispatch(getSale({ id }));
                        setShowSignSaleResultScreen(true);
                      }}
                      onSignPay={() => {
                        dispatch(getSale({ id }));
                        setShowSignPayResultScreen(true);
                      }}
                    />
                    <div className="ucp__right ucp__right--dynamic">
                      <SellingInfoContainer />
                    </div>
                  </div>
                </div>
              </TableWrapper>
            </div>
          </div>
        )}
      </div>
    </AppPageMain>
  );
};

export default AssetInfoPage;
